import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class RootDomainHelper {

  // Function to extract the root domain
  getRootDomain(): string {
    const hostname = window.location.hostname; // e.g., dev.eperearstikeskus.ee
    const parts = hostname.split(".");

    // If it's localhost or an IP address, return it as is
    if (parts.length <= 2 || hostname === "localhost") {
      return hostname;
    }

    // Return the root domain (the last two parts)
    return `.${parts.slice(-2).join(".")}`; // e.g., .eperearstikeskus.ee
  }

  getEnvironment(): string {
    const hostname = window.location.hostname; // dev.eperearstikeskus.ee
    return hostname.split('.')[0]; // localhost / dev / test / prelive / eperearstikeskus (live)
  }
}
